import React, { useState } from 'react';
import axios from 'axios';

const Card = ({ endpoint, fields }) => {
  const [formData, setFormData] = useState({});
  const [successMessage, setSuccessMessage] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCreate = async () => {
    try {
      await axios.post(endpoint, formData);
      setSuccessMessage('Data created successfully!');
    } catch (error) {
      console.error('Error creating data:', error);
    }
  };

  const closeMessage = () => setSuccessMessage('');

  const endpointPath = new URL(endpoint).pathname;

  return (
    <div className="card bg-white shadow-md rounded-lg p-6 mb-6 relative">
      <h2 className="text-2xl font-bold mb-4">{endpointPath}</h2>

      {/* Success Message Dialog */}
      {successMessage && (
        <div className="absolute top-0 left-0 w-full bg-green-500 text-white text-center p-3 rounded-t-lg">
          {successMessage}
          <button
            className="ml-4 text-sm underline"
            onClick={closeMessage}
          >
            Close
          </button>
        </div>
      )}

      <div className="form mt-4">
        {fields.map((field) => {
          const isDateTimeField = ['created_date', 'deadline_date', 'submission_date'].includes(field);
          return (
            <input
              key={field}
              name={field}
              type={isDateTimeField ? 'datetime-local' : 'text'}
              placeholder={field}
              onChange={handleInputChange}
              className="border border-gray-300 p-2 rounded mb-2 w-full"
            />
          );
        })}
        <button
          className="bg-green-500 text-white px-4 py-2 rounded mt-2"
          onClick={handleCreate}
        >
          Create
        </button>
      </div>
    </div>
  );
};

export default Card;
